import React from "react";
import QuizListForm from "./QuizListForm";
import { appTitle } from "../common/GeneralConfigurations";
import { deleteQuiz, getQuizList } from "../../api/QuizAPI/QuizAPI";
import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AdnMessageError from "../common/adnMessage/AdnMessageError";
import AdnMessageSuccess from "../common/adnMessage/AdnMessageSuccess";

const ManageQuizListPage = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [quizList, setQuizList] = useState([]);
  const [quizStatus, setQuizStatus] = useState();
  const [quizType, setQuizType] = useState("");
  const [quizReference, setQuizReference] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [orderBy, setOrderBy] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);

  const navigate = useNavigate();

  const checkLocalVariables = useCallback(() => {
    let storageVariables = JSON.parse(localStorage.getItem("QuizFilters"));

    if (storageVariables !== null) {
      setQuizType(storageVariables.quizType);
      setQuizReference(storageVariables.quizReference);
      setQuizStatus(storageVariables.quizStatus);
    }

    clearLocalVariables();
  }, []);

  useEffect(() => {
    document.title = `${appTitle} - ${t("quizList.title")}`;

    checkLocalVariables();
  }, [t, checkLocalVariables]);

  const fetchData = useCallback(async () => {
    await getQuizList({
      currentPage,
      quizReference,
      quizType,
      quizStatus,
      orderBy,
    })
      .then((res) => {
        if (res.status === 200) {
          setQuizList(res.data.result);
          setTotalRecords(res.data.totalRecords);
        } else {
          AdnMessageError(t("quizList.messages.errorSearchingQuizzes"));
        }
      })
      .catch(() => {
        AdnMessageError(t("quizList.messages.errorSearchingQuizzes"));
      })
      .finally(() => {
        setLoading(false);
      });
  }, [currentPage, quizReference, quizType, quizStatus, orderBy, t]);

  useEffect(() => {
    const quizTimeOut = setTimeout(async () => {
      await fetchData();
    }, 300);
    return () => {
      clearTimeout(quizTimeOut);
    };
  }, [fetchData]);

  const saveLocalVariables = () => {
    let localVariables = {
      quizType: quizType,
      quizReference: quizReference,
      quizStatus: quizStatus,
      currentPage: currentPage,
    };

    localStorage.setItem("QuizFilters", JSON.stringify(localVariables));
  };

  const clearLocalVariables = () => {
    localStorage.removeItem("QuizFilters");
  };

  const handleDelete = async (Id) => {
    await deleteQuiz(Id)
      .then((res) => {
        if (res.status === 200) {
          AdnMessageSuccess(t("quizList.messages.quizDeleted"));
          fetchData();
        } else {
          AdnMessageError(t("quizList.messages.cantDeleteQuiz"));
        }
      })
      .catch(() => {
        AdnMessageError(t("quizList.messages.cantDeleteQuiz"));
      });
  };

  const addQuiz = (route) => {
    saveLocalVariables();
    navigate(route.path);
  };

  const handleQuizTypeChange = (value) => {
    setQuizType(value);
    setCurrentPage(1);
  };

  const handleQuizReferenceChange = (value) => {
    setQuizReference(value);
    setCurrentPage(1);
  };

  const handleChangeQuizStatus = (value) => {
    setQuizStatus(value);
    setCurrentPage(1);
  };

  const handleOrderList = (pag, filter, sorter) => {
    sorter.order === "descend"
      ? setOrderBy("-" + sorter.field)
      : sorter.order === "ascend"
      ? setOrderBy("+" + sorter.field)
      : setOrderBy("");
  };

  return (
    <QuizListForm
      loading={loading}
      quizList={quizList}
      addQuiz={addQuiz}
      handleDelete={handleDelete}
      handleChangeQuizStatus={handleChangeQuizStatus}
      quizStatus={quizStatus}
      handleQuizTypeChange={handleQuizTypeChange}
      quizType={quizType}
      handleQuizReferenceChange={handleQuizReferenceChange}
      quizReference={quizReference}
      saveLocalVariables={saveLocalVariables}
      handleOrderList={handleOrderList}
      totalRecords={totalRecords}
      handleChangePage={setCurrentPage}
    />
  );
};

export default ManageQuizListPage;
